import classNames from 'clsx';
import * as React from 'react';

import * as styles from './SkeletonItem.css';

export const SkeletonItem: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={classNames(styles['skeleton'], styles['avatar'])}></div>
      <div className={classNames(styles['content'])}>
        <div className={classNames(styles['skeleton'], styles['text'])}></div>
        <div className={classNames(styles['skeleton'], styles['text'], styles['short'])}></div>
      </div>
    </div>
  );
};
